import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "px-4 pt-[4.7rem]" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "flow-root w-full" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search absolute top-2/4 -mt-2 left-3 text-surface-400" }, null, -1)
const _hoisted_6 = { class: "w-full mx-auto" }
const _hoisted_7 = {
  key: 1,
  class: "w-full flex pb-10"
}
const _hoisted_8 = {
  key: 1,
  class: "relative expanded"
}
const _hoisted_9 = { key: 2 }
const _hoisted_10 = { class: "w-full" }

import Button from 'primevue/button'
import ConfirmDialog from 'primevue/confirmdialog'
import InputText from 'primevue/inputtext'
import ProgressSpinner from 'primevue/progressspinner'
import { useConfirm } from "primevue/useconfirm"
import { onMounted, ref, Ref, provide, readonly } from 'vue'
import { useRoute } from 'vue-router'
import Table from '../components/DataTable.vue'
import DataTabs from '../components/DataTabs.vue'
import MatchManager from '../components/MatchManager.vue'
import TeamManager from '../components/TeamManager.vue'
import PlayerManager from '../components/PlayerManager.vue'
import VenueManager from '../components/VenueManager.vue'
import { useApiStore } from "../store/api/api"
// import { usePlayApiStore } from "../store/api/playApi"
import { useRealtimeApiStore } from "../store/api/realtimeApi"


// const api = useApiStore();
// const playApi = usePlayApiStore();
const typingTime = 200;

export default /*#__PURE__*/_defineComponent({
  __name: 'GameManagerView',
  setup(__props) {


const realtimeApi = useRealtimeApiStore();
const route = useRoute();
const confirm = useConfirm();
let typingTimer: any;
let teamTotal = ref(0)
const tabHeaders = ["Matches", "Teams", "Players", "Venues"]

const searchText = ref("")

let limit = 28
let expandedLimit = ref(20)
const offset = ref(0)

const isExpandedView = ref(false)
const isMatchManager = ref(false)
const isEditPage = ref(false)
const isMatchManagerInEditMode = ref(false)
const isEditMode = ref(false)

const data = ref([[], [], [], [],])
const searchedData = ref([[], [], [], [],])
const columns = [
    [
        { name: 'Match Name', key: 'name' },
        { name: 'ID', key: 'id' },
        { name: 'Start Date', key: 'startDate' },
        { name: 'Finish Date', key: 'finishDate' },
        { name: 'Match Days', key: 'matchDays' },
        { name: 'Match Type', key: 'matchType' },
        { name: 'Gender', key: 'gender' },
        { name: 'Winner', key: 'winner.name' },
        { name: 'Toss Winner', key: 'toss.name' },
        { name: 'Toss Decision', key: 'tossDecision' },
        { name: 'Result', key: 'result' },
        { name: 'Team One', key: 'team1.team.name' },
        { name: 'Team Two', key: 'team2.team.name' },
        { name: 'Season', key: 'season' },
        { name: 'Series', key: 'series.name' },
        { name: 'Venue', key: 'venue.name' },
    ],
    [
        { name: 'ID', key: 'id' },
        { name: 'Team Name', key: 'name' },
        { name: 'Country', key: 'country' },
        { name: 'Team Code', key: 'teamCode' },
        { name: 'League', key: 'league' },
        { name: 'Gender', key: 'gender' },
    ],
    [
        { name: 'ID', key: 'id' },
        { name: 'Name', key: 'name' },
        { name: 'Nick Names', key: 'nickNames' },
        { name: 'Date Of Birth', key: 'dateOfBirth' },
        { name: 'Gender', key: 'gender' },
        { name: 'Batting Hand', key: 'battingHand' },
        { name: 'Playing Role', key: 'playingRole' },
        { name: 'Bowling Style', key: 'bowlingStyle' },
        { name: 'Country', key: 'country' },
    ],
    [
        { name: 'ID', key: 'id' },
        { name: 'Stadium Name', key: 'name' },
        { name: 'City', key: 'city' },
        { name: 'Region', key: 'region' },
        { name: 'Country', key: 'country' },
        { name: 'Capacity', key: 'capacity' },
        { name: 'Location Lat', key: 'location.latitude' },
        { name: 'Location Long', key: 'location.longitude' },
    ]
]
const state = ref({
    isLoading: true,
})

const selected: Ref<object[]> = ref([{}, {}, {}, {}])

let parentTabActive = ref(0)

const confirmNavigateBack = () => {
    confirm.require({
        message: 'Are you sure you want to leave? Your changes will be lost',
        header: 'Confirmation',
        icon: 'pi pi-exclamation-triangle',
        rejectLabel: 'No',
        acceptLabel: 'Yes',
        accept: () => {
            isEditPage.value = false;
            isMatchManager.value = false;
            isMatchManagerInEditMode.value = false;
            isExpandedView.value = false;
            isEditMode.value = false;
        }
    });
};

onMounted(async () => {
    state.value.isLoading = true
    setTableSize()

    await realtimeApi.getAllMatches().then((value) => {
        data.value[0] = value.data;
        createMatchName()
    })

    await realtimeApi.getAllTeams().then((value) => {
        data.value[1] = JSON.parse(value.data).data;
    })

    await realtimeApi.getAllPlayers().then((value) => {
        data.value[2] = JSON.parse(value.data).data;
    })

    await realtimeApi.getAllVenues().then((value) => {
        data.value[3] = JSON.parse(value.data).data;
    })

    searchData()
    state.value.isLoading = false

})
provide("data", readonly(data))

/**
 * Sets the Table Query Limit based off window height
 * Sets the default selected columns based of window width
 */
function setTableSize() {
    const rowHeight = Number(window.getComputedStyle(document.querySelector("html")).getPropertyValue("line-height").replace(/[^0-9.]/g, '')) + 11
    const height = window.innerHeight
    const headerHeight = document.getElementsByTagName("nav")[0].getBoundingClientRect().height
    let informatrionCardHeightRec = document.getElementsByClassName("info")[0]
    let informatrionCardHeight = 0
    let allowedPaddingAndArbituaryValues = 185
    let tempLimit = (Math.floor((height - headerHeight - allowedPaddingAndArbituaryValues) / rowHeight))
    limit = tempLimit > 4 ? tempLimit : 5
    if (informatrionCardHeightRec !== undefined) {
        allowedPaddingAndArbituaryValues += 80
        informatrionCardHeight = informatrionCardHeightRec.getBoundingClientRect().height
        let tempLimit = (Math.floor((height - headerHeight - informatrionCardHeight - allowedPaddingAndArbituaryValues) / rowHeight))
        expandedLimit.value = tempLimit > 4 ? tempLimit : 5
    }
}

function searchData() {
    searchedData.value[parentTabActive.value] = []
    if (searchText.value != '') {
        searchedData.value[parentTabActive.value] = data.value[parentTabActive.value].filter((o: any) => o["name"].toUpperCase().includes(searchText.value.toUpperCase())) as []
    } else {
        searchedData.value[parentTabActive.value] = data.value[parentTabActive.value] as []
    }
    searchedData.value[parentTabActive.value]
    return searchedData
}

function clearTimer() {
    clearTimeout(typingTimer)
}

function startTimer() {
    clearTimeout(typingTimer)
    offset.value = 0
    typingTimer = setTimeout(searchData, typingTime)
}

function tabChange(activeValue: number) {
    selected.value = [{}, {}, {}, {}]
    parentTabActive = ref(activeValue)
    isExpandedView.value = false
    isMatchManager.value = false
    isEditPage.value = false
    offset.value = 0
    teamTotal.value = 0
    searchText.value = ''
    searchData()
}

function nextPage() {
    if (isExpandedView.value) {
        offset.value = offset.value + expandedLimit.value
    } else {
        offset.value = offset.value + limit
    }
}

function prevPage() {
    if (isExpandedView.value) {
        offset.value = offset.value - expandedLimit.value
    } else {
        offset.value = offset.value - limit
    }
}

function rowClicked(rowValues: { "id": string }, index: number) {
    if (parentTabActive.value !== 0) {

        isExpandedView.value = true
        selected.value[parentTabActive.value] = rowValues
        // selected.value[parentTabActive.value] = data.value[parentTabActive.value][index]
        offset.value = 0
    } else {
        isMatchManager.value = true
        selected.value[parentTabActive.value] = data.value[parentTabActive.value][index]
        // matchId.value = rowValues["id"].toString()
    }
}

function addNew() {
    if (parentTabActive.value !== 0) {
        isEditMode.value = true
        isExpandedView.value = true
        selected.value[parentTabActive.value] = {}
    } else {
        // matchId.value = undefined
        isMatchManager.value = true
        selected.value[parentTabActive.value] = {}
        isMatchManagerInEditMode.value = true
    }

}

async function getUpdatedMatches() {
    state.value.isLoading = true

    await realtimeApi.getAllMatches().then((value) => {
        data.value[0] = value.data;
        createMatchName()
    })
    state.value.isLoading = false
}

function createMatchName() {
    data.value[0] = data.value[0].map(function (el: any) {
        el.name = (el.team1.team.name + " vs " + el.team2.team.name + " at " + el.venue.name + " on " + (new Date(el.startDate)).toUTCString());
        return el as never;
    })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DataTabs, {
      headers: tabHeaders,
      parentTabActive: _unref(parentTabActive),
      onTabChange: tabChange,
      "in-edit-mode": isEditMode.value || isMatchManagerInEditMode.value
    }, {
      default: _withCtx((slotProps) => [
        (!isExpandedView.value && !isMatchManager.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                  onClick: addNew,
                  class: "bg-[#1f2937] hover:bg-slate-500 text-white float-right font-semi my-1.5 h-6 pt-0 pb-[1px] px-6 rounded items-center flex"
                }, " Add New "),
                _createElementVNode("span", _hoisted_4, [
                  _hoisted_5,
                  _createVNode(_unref(InputText), {
                    modelValue: searchText.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchText).value = $event)),
                    placeholder: "Search",
                    class: "py-0 my-1.5 text-center rounded-md border-2 shadow-none w-1/6 min-w-fit h-6",
                    onKeydown: clearTimer,
                    onKeyup: startTimer
                  }, null, 8, ["modelValue"])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                (!state.value.isLoading)
                  ? (_openBlock(), _createBlock(Table, {
                      key: 0,
                      data: searchedData.value[slotProps.index].slice(offset.value, offset.value + _unref(limit)),
                      columns: columns[slotProps.index],
                      hasTableRoute: true,
                      onNextPage: nextPage,
                      onPrevPage: prevPage,
                      limit: _unref(limit),
                      totalCount: searchedData.value[slotProps.index].length,
                      offset: offset.value,
                      onRowClicked: rowClicked
                    }, null, 8, ["data", "columns", "limit", "totalCount", "offset"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createVNode(_unref(ProgressSpinner), {
                        class: "justify-center w-90 h-90",
                        "attrs-color-black": "",
                        strokeWidth: "5",
                        animationDuration: "1s",
                        "aria-label": "Loading"
                      })
                    ]))
              ])
            ]))
          : _createCommentVNode("", true),
        (isExpandedView.value && !isMatchManager.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_unref(Button), {
                icon: "pi pi-chevron-left",
                onClick: _cache[1] || (_cache[1] = ($event: any) => {isEditMode.value ? confirmNavigateBack() : isExpandedView.value = false;}),
                class: "absolute left-0 top-0 mt-1 pl-0 pr-4 w-max",
                "aria-label": "Bookmark"
              }),
              (slotProps.index == 1)
                ? (_openBlock(), _createBlock(TeamManager, {
                    key: 0,
                    limit: _unref(expandedLimit),
                    "selected-team": selected.value[slotProps.index],
                    onReturn: _cache[2] || (_cache[2] = ($event: any) => (isExpandedView.value = false)),
                    onChangeEditStatus: _cache[3] || (_cache[3] = (state) => isEditMode.value = state),
                    onSetTableSize: setTableSize,
                    class: "py-2"
                  }, null, 8, ["limit", "selected-team"]))
                : (slotProps.index == 2)
                  ? (_openBlock(), _createBlock(PlayerManager, {
                      key: 1,
                      offset: offset.value,
                      limit: _unref(expandedLimit),
                      "selected-player": selected.value[slotProps.index],
                      onReturn: _cache[4] || (_cache[4] = ($event: any) => (isExpandedView.value = false)),
                      onChangeEditStatus: _cache[5] || (_cache[5] = (state) => isEditMode.value = state),
                      onSetTableSize: setTableSize,
                      class: "py-2"
                    }, null, 8, ["offset", "limit", "selected-player"]))
                  : (slotProps.index == 3)
                    ? (_openBlock(), _createBlock(VenueManager, {
                        key: 2,
                        limit: _unref(expandedLimit),
                        "selected-venue": selected.value[slotProps.index],
                        onReturn: _cache[6] || (_cache[6] = ($event: any) => (isExpandedView.value = false)),
                        onChangeEditStatus: _cache[7] || (_cache[7] = (state) => isEditMode.value = state),
                        onSetTableSize: setTableSize,
                        class: "py-2"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("> ")
                        ]),
                        _: 2
                      }, 1032, ["limit", "selected-venue"]))
                    : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        (slotProps.index == 0 && isMatchManager.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_unref(Button), {
                  icon: "pi pi-chevron-left",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => {isMatchManagerInEditMode.value ? confirmNavigateBack() : isMatchManager.value = false;}),
                  class: "float-left mt-4 pl-4 pr-2 w-max",
                  "aria-label": "Bookmark"
                }),
                _createVNode(MatchManager, {
                  venues: data.value[3],
                  teams: data.value[1],
                  "selected-match": selected.value[slotProps.index],
                  onChangeMatchEditState: _cache[9] || (_cache[9] = (state) => isMatchManagerInEditMode.value = state),
                  onExitMatchView: _cache[10] || (_cache[10] = ($event: any) => (isMatchManager.value = false)),
                  onSave: _cache[11] || (_cache[11] = ($event: any) => (getUpdatedMatches()))
                }, null, 8, ["venues", "teams", "selected-match"])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["parentTabActive", "in-edit-mode"]),
    _createVNode(_unref(ConfirmDialog))
  ]))
}
}

})